import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
//----- store
import { fetchPageData } from "../store/CourseDetails-actions";

import Box from "@material-ui/core/Box";
import TableGeralData from "../components/TableGeralData/TableGeralData";
import TableRunningActions from "../components/TableRunningActions/TableRunningActions";
import HeaderBreadCrumb from "../components/HeaderBreadCrumb/HeaderBreadCrumb";
import BoxTitle from "../components/BoxTitle/BoxTitle";
import IconTitle from "../components/IconTitle/IconTitle";

import Styles from "./CourseDetails.module.css";

const CourseDetails = () => {
	const dispatch = useDispatch();
	const [courseDetailsDataLoaded, setCourseDetailsData] = useState(false);
	const params = useParams();
	const history = useHistory();

	const CourseDetailsData = useSelector((state) => state.CourseDetailsData);

	const apiConfigData = useSelector((state) => state.apiConfigData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.courseDetails +
		"/" +
		params.courseId;
	
	console.log(params.courseId)

	const returnClickHandler = () => {
		history.goBack();
	};

	useEffect(() => {
		dispatch(fetchPageData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		if (CourseDetailsData.pageData.modality.id !== "") {
			console.log("CourseDetailsData", CourseDetailsData);
			setCourseDetailsData(true);
		}
	}, [CourseDetailsData]);

	return (
		<div className={Styles["courseDetails"]} style={{ color: "#ededed" }}>
			{courseDetailsDataLoaded && (
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						{/* <div className={"col-xs-12 title"}>
							<HeaderBreadCrumb />
						</div> */}
						<IconTitle
							title={CourseDetailsData.pageData.name}
							onClick={returnClickHandler}
						/>
					</div>
					<div className={"row"}>
						<div className={"col-xs-12"}>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<TableGeralData
											modality={
												CourseDetailsData.pageData
													.modality.name
											}
											status={
												CourseDetailsData.pageData
													.enrollmentStatus.nome
											}
											endDate={
												CourseDetailsData.pageData
													.shortEndDate
											}
											startDate={
												CourseDetailsData.pageData
													.shortStartDate
											}
											duration={
												CourseDetailsData.pageData
													.duration
											}
										/>
									</Box>
								</div>
							</div>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<Box
										component="div"
										className={"box-container"}
									>
										<BoxTitle title="Acções a decorrer" />
										<TableRunningActions
											TableRunningActionsData={
												CourseDetailsData
											}
										/>
									</Box>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default CourseDetails;
